// The structured reading and the derived events, as JSON. Deliberately plain: an
// operator copies from here into a ticket or a test, so what is shown must be
// exactly what the service produced.

export function JsonView({ value }: { value: unknown }): JSX.Element {
  return <pre className="json">{JSON.stringify(value, null, 2)}</pre>;
}
